import { NavLink } from "react-router-dom";
import CustomNavLinkProps from "../../services/models/customNavLinkProps.model";

function CustomNavLink({ to, name,href, isExact }: CustomNavLinkProps): JSX.Element {
    return <NavLink
  to={to}
  href={href}
  exact={isExact}
  activeClassName="
    font-semibold 
    md:bg-transparent
    py-2 md:py-0
    border-b-2 md:border-0 
    border-activeLink md:border-transparent
    !text-activeLink 
    font-sans
  "
  className="text-royalBlue font-sans w-full md:text-left text-center inline-block mt-3 text-sm"
>
  {name}
</NavLink>

}

export default CustomNavLink